import { app } from '../../../bootstrap/core';
import { documentListItem } from './documentListItem.component';
import { InboxDocumentService } from '../inbox.document.service';

app.component('documentListItem', documentListItem).service('inboxDocumentService', InboxDocumentService);
